import { FoxBizRequest, FoxRestBizClient } from "@/api/client";

class Board {

    constructor() {

    }

    /**
     * 게시글 상세 조회
     * @param {String} parameters 
     * @returns 
     */
    getBoardDetail(parameters) {

        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Koreit.Biz.KRTBoardBiz';
            request.methodId = 'GetKRTBoardContent';
            request.parameters.dic = parameters;

            service.execute(request).then(response => {

                const tables = response.data.result.value;

                if (!!response) resolve(tables);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 이전글 다음글 조회
     * @param {String} parameters 
     * @returns 
     */
    getKRTBoardContentPreNext(parameters) {

        return new Promise((resolve, reject) => {

            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Koreit.Biz.KRTBoardBiz';
            request.methodId = 'GetKRTBoardContentPreNext';
            request.parameters.dic = parameters;

            service.execute(request).then(response => {

                const tables = response.data.result.value;
                
                if(!!response) resolve(tables);
                else resolve(null)
            }).catch(error => reject(error));
        });
    }
}

export const board = new Board();